import { ToggleButton, ToggleButtonGroup, FormControl, FormHelperText, InputLabel, Box, useTheme } from "@mui/material";
import { useFormContext } from "../form/IForm";
import { useConfig } from "../store/selectors/useConfig";

const IToggle = ({ model, label, lookup = null, options = [], displayLabel = true, onChange: onChangeProp, ...rest }) => {
  const form = useFormContext();
  const theme = useTheme();
  const { getLookupValues } = useConfig();
  const lookupValues = lookup ? getLookupValues(lookup) : null;
  const toggleOptions = (options && options.length > 0) ? options : (lookupValues || []);
  const rawValue = form?.values[model];
  const value = rawValue !== undefined && rawValue !== null ? String(rawValue) : (toggleOptions[0]?.key != null ? String(toggleOptions[0].key) : "");

  const handleChange = (e, val) => {
    if (val != null) {
      form.setFieldValue(model, val);
      onChangeProp?.(e, val);
    }
  };

  return (
    <FormControl fullWidth error={form.touched[model] && Boolean(form.errors[model])}>
      {displayLabel && (
        <InputLabel shrink sx={{ color: theme.palette.sectionHeading ?? theme.palette.primary.main, fontWeight: "bold" }}>
          {label}
        </InputLabel>
      )}
      <Box
        sx={{
          backgroundColor: theme.palette.background.default,
          borderRadius: "999px",
          padding: "2px",
          mt: 1,
        }}
      >
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={handleChange}
          onBlur={form.handleBlur}
          name={model}
          fullWidth
          sx={{
            display: "flex",
            backgroundColor: theme.palette.background.default,
            borderRadius: "999px",
            border: `1px solid ${theme.palette.divider}`,
            overflow: "hidden",
          }}
          {...rest}
        >
          {(toggleOptions || []).map((opt) => (
            <ToggleButton
              key={String(opt.key)}
              value={String(opt.key)}
              sx={{
                flex: 1,
                border: "none !important",
                borderRadius: "0px !important",
                textTransform: "none",
                px: 1.5,
                py: 0.5,
                fontSize: "0.75rem",
                fontFamily: theme.typography.fontFamily,
                fontWeight: "bold",
                color: theme.palette.text.secondary,
                "&.Mui-selected": {
                  backgroundColor: `${theme.palette.primary.main} !important`,
                  color: "#fff !important",
                  borderRadius: "999px !important",
                },
                "&:hover": {
                  backgroundColor:
                    value === opt.key ? `${theme.palette.primary.main} !important` : "#f5f5f5",
                },
              }}
            >
              {opt.value}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
      {form.touched[model] && form.errors[model] && (
        <FormHelperText>{form.errors[model]}</FormHelperText>
      )}
    </FormControl>
  );
};

export default IToggle;
